import { createElement } from 'react';

import type { DatabaseColumnDefinition } from '@/lib/databases/types';
import type { DatabaseFooterResult } from '@/lib/databases/types';
import type { AggregateFunction } from '@/lib/databases/values';

import { FooterCalculateMenu } from './FooterCalculateMenu.web';

type DatabaseFooterRowProps = {
  visibleCols: DatabaseColumnDefinition[];
  footers: Record<string, DatabaseFooterResult> | undefined;
  columnAggregates: Record<string, AggregateFunction> | undefined;
  disabled?: boolean;
  titleWidth: number;
  dataColumnWidth: (colId: string) => number;
  onAggregateChange: (propertyId: string, fn: AggregateFunction | null) => void;
};

export function DatabaseFooterRow({
  visibleCols,
  footers,
  columnAggregates,
  disabled,
  titleWidth,
  dataColumnWidth,
  onAggregateChange,
}: DatabaseFooterRowProps) {
  return createElement(
    'tr',
    { className: 'cs-db-tr cs-db-footer-row' },
    createElement('td', {
      className: 'cs-db-td-footer cs-db-td-title',
      style: { width: titleWidth, minWidth: titleWidth },
    }),
    ...visibleCols.map((col) => {
      if (col.type === 'rollup') {
        return createElement('td', {
          key: col.id,
          className: 'cs-db-td-footer cs-db-td-cell',
          style: {
            width: dataColumnWidth(col.id),
            minWidth: dataColumnWidth(col.id),
          },
        });
      }
      const fn = columnAggregates?.[col.id];
      const result = footers?.[col.id];
      const colWidth = dataColumnWidth(col.id);
      return createElement(
        'td',
        {
          key: col.id,
          className: 'cs-db-td-footer cs-db-td-cell cs-db-td-cell--left',
          style: { width: colWidth, minWidth: colWidth },
        },
        createElement(FooterCalculateMenu, {
          columnType: col.type,
          selectedFn: fn,
          resultDisplay: result?.display,
          disabled,
          onSelect: (next) => onAggregateChange(col.id, next),
        }),
      );
    }),
  );
}
